import { GDSTransitions } from '@leagueplatform/genesis-core';

export const transitions: GDSTransitions = {
  defaultTime: '200ms',
};
